import _defineProperty from "/app/node_modules/.pnpm/next@13.5.3_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createSelector } from 'reselect';
import { UiState } from 'constants/ui';
import { createDeepEqualSelector } from 'state/selectors';
import { stateName } from './constants';

const localState = state => state[stateName];

export const getClosetPromotionCheckout = state => state.closetPromotions.checkout;
export const getClosetPromotionOrder = state => getClosetPromotionCheckout(state).order;
export const getOrderPrepareUiState = state => getClosetPromotionCheckout(state).orderPrepareUiState;
export const getActiveCheckoutModal = state => getClosetPromotionCheckout(state).activeModal;
export const getClosetPromotionMotivation = state => getClosetPromotionCheckout(state).motivation;
export const getPricing = state => state.closetPromotions.pricing;
export const getPricingUiState = state => state.closetPromotions.pricingUiState;
export const getIsCheckoutLoading = createDeepEqualSelector([getOrderPrepareUiState, (state, payInMethodsUiState) => payInMethodsUiState], (orderPrepareUiState, payInMethodsUiState) => {
  return orderPrepareUiState === UiState.Pending || payInMethodsUiState === UiState.Pending;
});
export const getIsOrderFree = createSelector(getClosetPromotionOrder, order => order && parseFloat(order.payable.amount) <= 0);
export const isOrderConfirmationDisabled = createSelector(getClosetPromotionOrder, order => {
  if (!order) return true;
  return order.isTaxCoverageAvailable === false;
});
export const getIds = createSelector(localState, _ref => {
  let {
    ids
  } = _ref;
  return ids;
});
export const getById = createSelector(localState, _ref2 => {
  let {
    byId
  } = _ref2;
  return byId;
});
export const getSeenClosetIds = createSelector(localState, _ref3 => {
  let {
    seenClosetIds
  } = _ref3;
  return seenClosetIds;
});
export const getClosetList = createSelector(getIds, getById, (ids, byId) => ids.map(id => byId[id]));
export const getClosetListWithBanner = createSelector(getClosetList, list => {
  if (!list.length) return list;
  const item = list[0];
  return [_objectSpread(_objectSpread({}, item), {}, {
    showBanner: true
  }), ...list.slice(1)];
});